<template>
  <form
    autocomplete="off"
    class="gap-0 gap-y-4"
    @submit.prevent="submitForm"
  >
    <template v-if="notificationSent">
      <div class="col-span-12 mb-12">
        <h3 class="mb-2">
          You will be Notified!
        </h3>

        <span class="text-secondary mb-5 block">
          You have been subscribed to receive notifications for the event
        </span>

        <p class="text-[15px]">
          You have been subscribed to this Event. When photos are available you will be notified by email at
          <strong>{{ authStore.user.email }}</strong>.
        </p>

        <AppButton
          class="btn btn-solid btn-secondary rounded-none w-full absolute left-0 bottom-0 p-4"
          type="button"
          @click="$emit('close');"
        >
          Ok
        </AppButton>
      </div>
    </template>

    <template v-else>
      <div
        class="col-span-12 flex flex-col items-center"
        :class="!error ? 'mb-18' : ''"
      >
        <template v-if="authStore.user">
          <h3 class="mb-5">
            Click to get notified
          </h3>

          <span class="text-center block mt-1">
            You will be notified via email once the event images are available online. Thank you for your patience!
          </span>

          <AppButton
            class="btn btn-solid btn-secondary rounded-none w-full absolute left-0 bottom-0 p-4"
            :processing="isSubmitting"
          >
            Notify Me
          </AppButton>
        </template>

        <template v-else>
          <h2 class="mb-5">
            Account Required
          </h2>

          <span class="block mt-1 mb-2">
            You must be logged in to be notified.
          </span>

          <div class="absolute bottom-8 flex items-center justify-center gap-4 w-sm">
            <AppButton
              class="btn btn-outline btn-secondary py-3 w-1/2"
              @click="$emit('close')"
            >
              Okay
            </AppButton>
          </div>
        </template>
      </div>

      <template v-if="error">
        <div class="text-red-500 p-2 bg-red-100 rounded col-span-12 block mb-12">
          {{ error }}
        </div>
      </template>
    </template>
  </form>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { ref } from 'vue';
import { useRoute } from 'vue-router';

import { AppButton } from '@/components/app';

import { useFormSubmit, useHttp } from '@/composables';
import { useAuthStore } from '@/store';

const { error, errors } = useFormSubmit();

const isSubmitting = defineModel('isSubmitting', { type: Boolean });

const route = useRoute();

const authStore = useAuthStore();

defineEmits(['close']);

defineProps({
  event: {
    type: Object,
    required: true,
  },
});

const notificationSent = ref(false);

const submitForm = async () => {
  error.value = null;
  errors.value = null;
  isSubmitting.value = true;

  const response = await useHttp().post(`/events/${route.params.slug}/notifications`);

  if (response.statusCode === HttpStatusCode.Ok) {
    notificationSent.value = true;

  } else if (response.statusCode === HttpStatusCode.UnprocessableEntity) {
    error.value = response.errors.email ? response.errors.email : response.errors.event;
  } else if (response.statusCode === HttpStatusCode.Unauthorized) {
    error.value = response.exception;
  } else if (response.statusCode === HttpStatusCode.TooManyRequests) {
    error.value = response.exception;
  } else {
    error.value = response.exception;
  }

  isSubmitting.value = false;
};
</script>
